<template>
  <el-button-group>
    <el-button @click="computeTime(7)">最近一周</el-button>
    <el-button @click="computeTime(30)">最近一个月</el-button>
    <el-button @click="computeTime(90)">最近三个月</el-button>
  </el-button-group>
</template>

<script>
import moment from 'moment'
export const formatDays = (days) => {
  const time = new Date()
  time.setTime(time.getTime() - 3600 * 1000 * 24 * days)
  return moment(time).format('YYYY-MM-DD')
}

export default {
  props: {
    start: {
      type: String,
      default: ''
    },
    end: {
      type: String,
      default: ''
    }
  },
  computed: {
    timeWatch: function() {
      return {
        start: this.start,
        end: this.end
      }
    }
  },
  watch: {
    timeWatch: {
      handler(obj) {
        const {
          start,
          end
        } = obj
        this.$emit('onDatePicker', [
          start,
          end
        ])
      },
      immediate: true
    }
  },
  methods: {
    computeTime(days) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * days)
      this.start = moment(start).format('YYYY-MM-DD')
      this.end = moment(end).format('YYYY-MM-DD')
    }
  }
}
</script>
